"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.export.csv': '导出CSV',
    'reports.export.excel': '导出Excel',
};
